import { SAFE_FRAMEWORK_ADDRESS } from "@safecoin/safe/utils";
//#region src/types/transfer-policy.ts
/** The Transfer Policy module. */
const TRANSFER_POLICY_MODULE = `${SAFE_FRAMEWORK_ADDRESS}::transfer_policy`;
/** Name of the event emitted when a TransferPolicy for T is created. */
const TRANSFER_POLICY_CREATED_EVENT = `${TRANSFER_POLICY_MODULE}::TransferPolicyCreated`;
/** The Transfer Policy Type */
const TRANSFER_POLICY_TYPE = `${TRANSFER_POLICY_MODULE}::TransferPolicy`;
/** The Transfer Policy Cap Type */
const TRANSFER_POLICY_CAP_TYPE = `${TRANSFER_POLICY_MODULE}::TransferPolicyCap`;
/** The Kiosk Lock Rule */
const KIOSK_LOCK_RULE = "kiosk_lock_rule::Rule";
/** The Royalty rule */
const ROYALTY_RULE = "royalty_rule::Rule";
//#endregion
export { KIOSK_LOCK_RULE, ROYALTY_RULE, TRANSFER_POLICY_CAP_TYPE, TRANSFER_POLICY_CREATED_EVENT, TRANSFER_POLICY_MODULE, TRANSFER_POLICY_TYPE };

//# sourceMappingURL=transfer-policy.mjs.map